import { FC, useEffect, useMemo, useState } from "react";
// Hooks
import useNavigateTo from "hooks/useNavigateTo";
import { useAppDispatch, useAppSelector } from "hooks/useStore";
// Redux
import { setPageIndex } from "store/pages/pagesSlice";
import { selectPage, selectPageIndex } from "store/pages/pagesSelectors";
import { selectQuiz } from "store/quiz/quizSelectors";
import IQuiz from "models/Quiz";
import PageTypes from "types/PageTypes";
import Paths from "types/Paths";
import QuizTypes from "types/QuizTypes";
 
const PageHandler:FC = () => {
  const dispatch = useAppDispatch();
  const pageIndex = useAppSelector(selectPageIndex);
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const page = useAppSelector(selectPage);

  const lastPage = useMemo(() => {
    switch (quiz.type) {
      case QuizTypes.BeatTheExpert:
        return 'beat-the-expert-result';
      case QuizTypes.Scoring:
        return 'scoring-result';
      case QuizTypes.Streak:
        return 'streak-handler';
      default:
        return 'register';
    }
  }, [quiz.type]);

  const [rendered, setRendered] = useState(false);

  const navigateTo = useNavigateTo();

  const paths:Record<PageTypes, Paths> = {
    [PageTypes.Banner]: 'media',
    [PageTypes.Question]: 'question',
    [PageTypes.AdditionalQuestions]: 'additionalQuestions',
    [PageTypes.Timer]: 'timer',
    [PageTypes.Waiting]: 'waiting'
  }

  useEffect(() => {
    if (!rendered) return;
    if (!page && pageIndex > 0) navigateTo(lastPage);
    if (!page) return;
    
    navigateTo(paths[page.type]);
    // eslint-disable-next-line
  }, [page, rendered]);

  useEffect(() => {
    dispatch(setPageIndex(pageIndex + 1));
    setRendered(true);
    return () => {
      setRendered(false);
    }
    // eslint-disable-next-line
  }, []);

  return null;
}
 
export default PageHandler;
